import { fetchAPI } from "./utils";
import { MessageResponse } from "../types/types";

import {
    CreateSingleTrackParams,
    UpdateSingleTrackParams,
    DeleteSingleTrackParams,
    GetSingleTrackParams,
    GetFilteredSingleTracksParams,
} from "../types/requestInputs";

import { GetSingleTrackResponse } from "../types/requestsOutputs";

// Fetch all single tracks
export const getSingleTracks = async ({ token }: GetSingleTrackParams): Promise<GetSingleTrackResponse> => {
    return fetchAPI<GetSingleTrackResponse>("/get-single-tracks", "GET", undefined, token);
};

// Fetch story single tracks related to a company
export const getStorySingleTracks = async ({ token }: GetSingleTrackParams): Promise<GetSingleTrackResponse> => {
    return fetchAPI<GetSingleTrackResponse>("/get-story-single-tracks", "GET", undefined, token);
};

// Fetch all single tracks with optional folder and category filters
export const getAllSingleTracks = async ({
    token,
    data,
}: GetFilteredSingleTracksParams): Promise<GetSingleTrackResponse> => {
    return fetchAPI<GetSingleTrackResponse>("/get-all-single-tracks", "POST", data, token);
};

export const createSingleTrack = async ({ token, data }: CreateSingleTrackParams): Promise<MessageResponse> => {
    return await fetchAPI<MessageResponse>("/create-single-track", "POST", data, token);
};

export const createSingleTrackStory = async ({
    token,
    data,
}: {
    token: CreateSingleTrackParams["token"];
    data: Omit<CreateSingleTrackParams["data"], "categoryId">;
}): Promise<MessageResponse> => {
    return await fetchAPI<MessageResponse>("/create-single-track-story", "POST", data, token);
};

export const updateSingleTrack = async ({
    token,
    trackId,
    data,
}: UpdateSingleTrackParams): Promise<MessageResponse> => {
    return await fetchAPI<MessageResponse>("/update-single-track", "POST", { id: trackId, ...data }, token);
};

export const deleteSingleTrack = async ({ token, trackId }: DeleteSingleTrackParams): Promise<MessageResponse> => {
    return await fetchAPI<MessageResponse>("/delete-single-track", "POST", { trackId }, token);
};
